module.exports = __webpack_public_path__ + "img/bonus-komisi-illustration.1af07dd8.png";